import { render } from 'react-dom'
import { App } from './components/App'
import './i18n'

render(<App />, document.getElementById('root'))
